import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"min-width":"950px"}
}
const _hoisted_2 = {
  class: "modal-content px-10 py-10",
  "element-loading-background": "rgba(122, 122, 122, 0.3)"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom mb-10" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs-1" }, "Add Payment Service")
], -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-8" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "me-9",
  for: "Deposit"
}, "Deposit", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "me-9",
  for: "Withdrawal"
}, "Withdrawal", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "text-end mt-15" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["disable"]

import { ref, reactive } from "vue";
import { hideModal, showModal } from "@/core/helpers/dom";
import { type FormRules, FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";
import PaymentService from "../services/PaymentService";
import { Field } from "vee-validate";
import UploadImage from "./UploadImage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentServiceCreate',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const { t } = useI18n();
const isLoading = ref(false);
const paymentCreateShowRef = ref(null);
const paymentFormRef = ref<FormInstance>();
const categoryList = ref([]);
const platformList = ref([] as any);
const tab = ref("Deposit");
const store = useStore();
const uploadImageRef = ref<any>(null);
const currencyList = store.state.AuthModule.config.currencyAvailable;

const initFormData = ref({
  isActivated: 0,
  isHighDollarEnabled: 0,
  isAutoDepositEnabed: 0,
  methodType: "Deposit",
  name: "",
  commentCode: "",
  percentage: 100,
  description: "",
  currencyId: "",
  canDeposit: 0,
  canWithdraw: 0,
  initialValue: 0,
  minValue: 0,
  maxValue: 0,
  platform: "",
  group: "",
});

const formData = ref({
  isActivated: 0,
  isHighDollarEnabled: 0,
  isAutoDepositEnabed: 0,
  methodType: "Deposit",
  name: "",
  commentCode: "",
  percentage: 100,
  description: "",
  currencyId: "",
  canDeposit: 0,
  canWithdraw: 0,
  initialValue: 0,
  minValue: 0,
  maxValue: 0,
  platform: "",
  group: "",
  logo: "",
});

const addPaymentService = async () => {
  if (
    formData.value.name == "" ||
    formData.value.platform == "" ||
    formData.value.group == "" ||
    formData.value.currencyId == ""
  ) {
    MsgPrompt.error("Name, Platform, Category and Currency are required");
    return;
  }

  formData.value.initialValue = parseFloat(formData.value.initialValue);
  formData.value.minValue = parseFloat(formData.value.minValue);
  formData.value.maxValue = parseFloat(formData.value.maxValue);

  isLoading.value = true;
  try {
    await uploadImageRef.value.uploadImage().then(() => {
      const res = uploadImageRef.value.imageUrl;
      if (res[0] != undefined) {
        formData.value.logo = res[0];
      }
    });
    console.log("formData.value", formData.value);
    await PaymentService.postPaymentServices(formData.value);
    MsgPrompt.success(t("tip.submitSuccess")).then(() => {
      emits("eventSubmit");
      close();
    });
    formData.value = ref(JSON.parse(JSON.stringify(initFormData)));
  } catch (error) {
    MsgPrompt.error("Failed to submit");
  }

  isLoading.value = false;
};

const show = (data, _platform, _tab) => {
  platformList.value = _platform;
  categoryList.value = data;
  tab.value = _tab;

  formData.value = JSON.parse(JSON.stringify(initFormData.value));
  formData.value.methodType = tab.value;
  showModal(paymentCreateShowRef.value);
};

const close = () => {
  hideModal(paymentCreateShowRef.value);
};



__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    role: "dialog",
    ref_key: "paymentCreateShowRef",
    ref: paymentCreateShowRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            model: formData.value,
            ref_key: "paymentFormRef",
            ref: paymentFormRef,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_form_item, {
                      label: "Activate",
                      prop: "isActivated"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: formData.value.isActivated,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.isActivated) = $event)),
                          "active-value": 1,
                          "inactive-value": 0
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "High Dollar",
                      prop: "isHighDollarEnabled",
                      class: "ms-9"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: formData.value.isHighDollarEnabled,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.isHighDollarEnabled) = $event)),
                          "active-value": 1,
                          "inactive-value": 0
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Auto Deposit",
                      prop: "isAutoDepositEnabed",
                      class: "ms-9"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: formData.value.isAutoDepositEnabed,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.isAutoDepositEnabed) = $event)),
                          "active-value": 1,
                          "inactive-value": 0
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_form_item, { label: "Method Type" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(Field), {
                          modelValue: formData.value.methodType,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.methodType) = $event)),
                          class: "form-check-input widget-9-check me-3",
                          type: "radio",
                          name: "Deposit",
                          value: "Deposit"
                        }, null, 8, ["modelValue"]),
                        _hoisted_9,
                        _createVNode(_unref(Field), {
                          modelValue: formData.value.methodType,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.methodType) = $event)),
                          class: "form-check-input widget-9-check me-3",
                          type: "radio",
                          name: "Withdrawal",
                          value: "Withdrawal"
                        }, null, 8, ["modelValue"]),
                        _hoisted_10
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_form_item, {
                  label: "Name (Required)",
                  prop: "name",
                  class: "col-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.name,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.name) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Code",
                  prop: "commentCode",
                  class: "col-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.commentCode,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.commentCode) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Percentage",
                  prop: "percentage",
                  class: "col-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.percentage,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.percentage) = $event))
                    }, {
                      append: _withCtx(() => [
                        _createTextVNode("%")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_form_item, {
                  label: "Platform (Required)",
                  prop: "platform",
                  class: "col-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: formData.value.platform,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.platform) = $event)),
                      placeholder: "Select"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformList.value, (value, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: _unref(t)(`type.paymentTypes.${value}`),
                            value: value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Category (Required)",
                  prop: "group",
                  class: "col-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.group,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.group) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Currency (Required)",
                  prop: "currencyId",
                  class: "col-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: formData.value.currencyId,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.currencyId) = $event)),
                      placeholder: "Select"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyList), (value, i) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: i,
                            label: _ctx.$t(`type.currency.${value}`),
                            value: value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_form_item, {
                  label: "Initial Minimum Amount",
                  prop: "initialValue",
                  class: "col-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      modelValue: formData.value.initialValue,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.initialValue) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Minimum Amount",
                  prop: "minValue",
                  class: "col-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      modelValue: formData.value.minValue,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.minValue) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Maximum Amount",
                  prop: "maxValue",
                  class: "col-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      modelValue: formData.value.maxValue,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.maxValue) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, {
                label: "Description",
                prop: "description"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.description,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.description) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Upload Payment Logo",
                prop: "image"
              }, {
                default: _withCtx(() => [
                  _createVNode(UploadImage, {
                    ref_key: "uploadImageRef",
                    ref: uploadImageRef
                  }, null, 512)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: "btn btn-secondary me-5",
                  onClick: _withModifiers(close, ["prevent"])
                }, _toDisplayString(_ctx.$t("action.close")), 9, _hoisted_15),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  disable: isLoading.value,
                  onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (addPaymentService()), ["prevent"]))
                }, _toDisplayString(_ctx.$t("action.submit")), 9, _hoisted_16)
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])), [
        [_directive_loading, isLoading.value]
      ])
    ])
  ], 512))
}
}

})